import { Client } from 'urql';
import { suburbPageQuery } from './suburbPageQuery';

export const fetchSuburbPage = async ({
  client,
  slug,
  toggleFlatmatesBrick,
}: {
  client: Client;
  slug: string;
  toggleFlatmatesBrick: boolean;
}) => {
  const { data, error } = await client
    .query(suburbPageQuery, { slug, toggleFlatmatesBrick })
    .toPromise();
  return { data, error };
};
